<template>
    <DataTable ref="horseHistoryChangesTable" :value="changesList" dataKey="revision" size="small"
               selection-mode="single" @row-click="onRowSelect">
        <Column field="timestamp" :header="$t('message.horseEdit.history.table.date')" class="w-3">
            <template #body="{ data }">
                {{ data.timestamp }}
            </template>
        </Column>
        <Column field="user" :header="$t('message.horseEdit.history.table.user')" class="w-6">
            <template #body="{ data }">
                {{ data.username }}
            </template>
        </Column>

        <template #empty>
            {{ $t('message.other.emptyTable') }}
        </template>
    </DataTable>
</template>

<script>

import Column from "primevue/column";
import DataTable from "primevue/datatable";
import {ScrollToUtils} from "@/utils/ScrollToUtils";

export default {
    name: "HorseHistoryChangesDataTable",
    components: {
        Column,
        DataTable,
    },

    emits: ["update:modelValue", "showRevision"],

    data() {
        return {
            loading: false,
        };
    },

    props: {
        changesList: null
    },

    methods: {
        onRowSelect(event) {
            this.$emit("showRevision", event);
        },
    },

};
</script>



<style scoped lang="scss">

</style>
